export const getCourseBackgroundImage = (course) => {
    // Check if course has courseMaterialSets
    if (!course.courseMaterialSets || course.courseMaterialSets.length === 0) {
        return null;
    }

    // Find the cover photo material set
    const coverPhotoSet = course.courseMaterialSets.find(
        set => set.title === "Cover photo"
    );

    if (!coverPhotoSet || !coverPhotoSet.materials || coverPhotoSet.materials.length === 0) {
        return null;
    }

    // Get the thumbnail URL from the first material
    const material = coverPhotoSet.materials[0];
    if (material.driveFile && material.driveFile.driveFile) {
        return material.driveFile.driveFile.thumbnailUrl;
    }

    return null;
};

// Fallback color based on course ID (matches Google Classroom colors)
export const getCourseColor = (courseId) => {
    const colors = [
        '#1a73e8', // Blue
        '#0d9488', // Teal
        '#d97706', // Orange
        '#dc2626', // Red
        '#9333ea', // Purple
        '#ec4899', // Pink
        '#16a34a', // Green
        '#0891b2'  // Cyan
    ];

    // Use course ID to pick a consistent color
    const index = parseInt(courseId) % colors.length;
    return colors[index];
};